import {type IAsset, AssetStatus} from '../schema';

export const assetNotCheckedOut = (asset?: IAsset) => {
	if (!asset) return false;
	return asset.status !== AssetStatus.CHECKOUT;
};
